import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { getCurrentUsername, getLaunchDarklyClientId } from '@mode/shared/util-dom';
import { LaunchDarklyFlagsDataService } from './launch-darkly-flags-data.service';

@Injectable()
/**
 * For starting LD initialization before other CanActivate or CanLoad guards run
 */
export class LoadFeatureFlagsGuard implements CanActivate {
  constructor(private launchDarklyFlagsDataService: LaunchDarklyFlagsDataService) {}

  async initFlags(org: string) {
    // TODO: don't use meta-helpers directly from here, use a facade/service instead
    const username = getCurrentUsername(window.document) || undefined;
    const currentOrg = this.launchDarklyFlagsDataService.currentContext?.organization;

    // TODO: wire up billing_plan_code and email
    // Check if org changed, if so, reidentify
    if (this.launchDarklyFlagsDataService.userKey != null) {
      if (currentOrg !== org) {
        await this.launchDarklyFlagsDataService.update(username, {
          billing_plan_code: undefined,
          email: undefined,
          orgName: org,
          organization: org,
        });
      }

      // if org hasn't changed, don't do anything
    } else {
      const sdkKey = getLaunchDarklyClientId(window.document);
      if (sdkKey != null) {
        await this.launchDarklyFlagsDataService.init(sdkKey, username, {
          billing_plan_code: undefined,
          email: undefined,
          orgName: org,
          organization: org,
        });
      } else {
        throw new Error('Unable to get LD client key');
      }
    }
  }

  canActivate(route: ActivatedRouteSnapshot) {
    const org = route.paramMap.get('orgName');
    if (org != null) {
      return this.initFlags(org)
        .then(() => true)
        .catch((err) => {
          // TODO: Log somewhere
          console.error(err);
          return true;
        });
    }

    // if can't find the org, just continue and hope the page loads
    return true;
  }
}
